import React from 'react';
import Icon from '../../../components/AppIcon';

const AssignmentCard = ({ assignment, isNew = false }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'pending': return 'bg-warning/10 text-warning border-warning';
      case 'confirmed': return 'bg-primary/10 text-primary border-primary';
      case 'in_progress': return 'bg-accent/10 text-accent border-accent';
      case 'completed': return 'bg-success/10 text-success border-success';
      case 'cancelled': return 'bg-muted text-muted-foreground border-border';
      default: return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'pending': return 'Pending';
      case 'confirmed': return 'Confirmed';
      case 'in_progress': return 'In Progress';
      case 'completed': return 'Completed';
      case 'cancelled': return 'Cancelled';
      default: return status;
    }
  };

  const getPriorityColor = (priority) => {
    if (priority >= 8) return 'text-error';
    if (priority >= 5) return 'text-warning';
    return 'text-muted-foreground';
  };

  const daysUntilDue = assignment?.dueDate 
    ? Math.ceil((new Date(assignment.dueDate) - new Date()) / (1000 * 60 * 60 * 24))
    : null;

  return (
    <div className={`bg-muted/50 border rounded-lg p-5 hover:shadow-md transition-all duration-200 ${
      isNew ? 'border-primary animate-pulse' : 'border-border'
    }`}>
      {isNew && (
        <div className="mb-2 flex items-center gap-2">
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-primary text-primary-foreground text-xs font-semibold rounded">
            <Icon name="Bell" size={12} />
            NEW
          </span>
        </div>
      )}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-1">
            {assignment?.lineGroup?.characterName}
          </h3>
          <p className="text-sm text-muted-foreground">
            {assignment?.lineGroup?.playTitle}
          </p>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(assignment?.status)}`}>
          {getStatusLabel(assignment?.status)}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="FileText" size={16} className="text-muted-foreground" />
          <span className="text-sm text-foreground">
            {assignment?.lineGroup?.lineCount || 0} lines
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="BarChart3" size={16} className="text-muted-foreground" />
          <span className="text-sm text-foreground">
            Complexity: {assignment?.lineGroup?.complexityRating || 'N/A'}/5
          </span>
        </div>
      </div>
      <div className="flex items-center justify-between pt-3 border-t border-border">
        <div className="flex items-center gap-4">
          {assignment?.dueDate && (
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} className="text-muted-foreground" />
              <span className={`text-sm ${
                daysUntilDue !== null && daysUntilDue <= 2 ? 'text-error font-medium' : 'text-muted-foreground'
              }`}>
                {daysUntilDue !== null && daysUntilDue >= 0 
                  ? `${daysUntilDue} ${daysUntilDue === 1 ? 'day' : 'days'} left`
                  : 'Overdue'
                }
              </span>
            </div>
          )}
          <div className="flex items-center gap-2">
            <Icon name="Flag" size={16} className={getPriorityColor(assignment?.priority)} />
            <span className={`text-sm ${getPriorityColor(assignment?.priority)}`}>
              Priority {assignment?.priority}/10
            </span>
          </div>
        </div>
      </div>
      {assignment?.notes && (
        <div className="mt-3 pt-3 border-t border-border">
          <p className="text-xs text-muted-foreground italic">
            Note: {assignment?.notes}
          </p>
        </div>
      )}
    </div>
  );
};

export default AssignmentCard;